import { InjectionToken, PLATFORM_ID, inject, FactoryProvider } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const WINDOW = new InjectionToken<Window | null>('Global window object', {
  factory: () => {
    const platformId = inject(PLATFORM_ID);
    return isPlatformBrowser(platformId) ? window : null;
  }
});

const windowFactory = (): Window | null => {
  const platformId = inject(PLATFORM_ID);
  return isPlatformBrowser(platformId) ? window : null;
};

export const WINDOW_PROVIDER: FactoryProvider = {
  provide: WINDOW,
  useFactory: windowFactory
};
